export const normalizeSnakeToCamel = (obj: unknown): unknown => {
  if (Array.isArray(obj)) {
    return obj.map(normalizeSnakeToCamel);
  }
  if (obj && typeof obj === "object") {
    const out: Record<string, unknown> = {};
    const record = obj as Record<string, unknown>;
    for (const k of Object.keys(record)) {
      const ck = k.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
      out[ck] = normalizeSnakeToCamel(record[k]);
    }
    return out;
  }
  return obj;
};
